import Api from '.';

class AuthApi extends Api {
  base_endpoint = 'auth';

  validateCode(email, code) {
    return this.doRequest('post', `/`, { email, code });
  }

  validateEmail(email) {
    return this.doRequest('post', `/email`, { email });
  }

  recovery(email) {
    return this.doRequest('post', `recovery-password`, { email });
  }
}

export default new AuthApi();
